export default __webpack_public_path__ + "images/no.96d6ee4.png";